import {
  faEnvelope,
  faGlobe,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import {
  ImgAndresAvelinoPuno,
  ImgCarouselAacIquitos,
  ImgCarouselAacIquitos2,
  ImgCarouselAacIquitos3,
  ImgCarouselAacIquitos4,
  ImgCarouselAacIquitos5,
  ImgCarouselAacIquitos6,
  ImgCarouselAacLocumba,
  ImgCarouselAacLocumba2,
  ImgCarouselAacLocumba3,
  ImgCarouselAacLocumba4,
  ImgCarouselAacPuno,
  ImgCarouselAacPuno2,
  ImgCarouselAacPuno3,
  ImgCarouselAacPuno4,
  ImgCarouselAacPuno5,
  ImgCarouselAacTumbes,
  ImgCarouselAacTumbes2,
  ImgCarouselAacTumbes3,
  ImgCarouselAacTumbes4,
  ImgCarouselAacTumbes5,
  ImgCarouselAacTumbes6,
  ImgCarouselEjercitoArequipa,
  ImgCarouselEjercitoArequipa2,
  ImgCarouselEjercitoArequipa3,
  ImgCarouselEjercitoArequipa4,
  ImgCarouselEjercitoArequipa5,
  ImgCarouselFranciscoBolonesCusco,
  ImgCarouselFranciscoBolonesiCusco5,
  ImgCarouselFranciscoBolonesiCusco6,
  ImgCarouselFranciscoBolonesiCusco7,
  ImgCarouselFranciscoBolonesiCusco8,
  ImgCarouselInclanPiura,
  ImgCarouselInclanPiura2,
  ImgCarouselInclanPiura3,
  ImgCarouselInclanPiura4,
  ImgCarouselInclanPiura5,
  ImgCarouselMariaMontesori,
  ImgCarouselMariaMontesori2,
  ImgCarouselMariaMontesori3,
  ImgCarouselMariaMontesori4,
  ImgCarouselMariaMontesori5,
  ImgCarouselMariaMontesori6,
  ImgCarouselMiguelSullana2,
  ImgCarouselMiguelSullana3,
  ImgCarouselMiguelSullana4,
  ImgCarouselMiguelSullana5,
  ImgCarouselNuestrosHeroes,
  ImgCarouselNuestrosHeroes1,
  ImgCarouselNuestrosHeroes2,
  ImgCarouselNuestrosHeroes3,
  ImgCarouselNuestrosHeroes4,
  ImgCarouselNuestrosHeroes5,
  ImgCarouselRamonZavalaLocumba,
  ImgCarouselRamonZavalaLocumba2,
  ImgCarouselRamonZavalaLocumba3,
  ImgCarouselRamonZavalaLocumba4,
  ImgCarouselTarapaca2,
  ImgCarouselTarapaca4,
  ImgCarouselTarapaca5,
  ImgCarouselTarapaca6,
  ImgFranciscoBolonesiCusco,
  ImgIeMariaMontessori,
  ImgJoseJuaquinPiura,
  ImgMiguelCortezSullana,
  ImgTarapacaIquitos,
  Inst12,
  Inst13,
  Inst15,
  Inst16,
  Inst17,
  Inst18,
  Inst19,
  Inst20,
  Inst21,
  Inst22,
  LogoAacTumbes,
} from "../images";

export const provinceInstitutes = [
  {
    image: LogoAacTumbes,
    imgCarousels: [
      ImgCarouselAacTumbes,
      ImgCarouselAacTumbes2,
      ImgCarouselAacTumbes3,
      ImgCarouselAacTumbes4,
      ImgCarouselAacTumbes5,
      ImgCarouselAacTumbes6,
    ],
    title1: "Institución Educativa",
    title2: "MCAL ANDRÉS AVELINO CÁCERES - TUMBES",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/Mariscal2019SAC",
        url: "facebook.com/Mariscal2019SAC",
      },
      {
        icon: faEnvelope,
        name: "iemaac2018@hotmail.com",
        url: "mailto:iemaac2018@hotmail.com",
      },
      {
        icon: faLocationDot,
        name: "Andrés Avelino Cáceres - Tumbes",
        url: "https://goo.gl/maps/iyUdXUdGKhBXjfFBA",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1LmkgUYdeuqJo9L-PtBzeSucyv6cueCq4/view?usp=sharing",
  },
  {
    image: Inst20,
    imgCarousels: [
      ImgMiguelCortezSullana,
      ImgCarouselMiguelSullana2,
      ImgCarouselMiguelSullana3,
      ImgCarouselMiguelSullana4,
      ImgCarouselMiguelSullana5,
    ],
    title1: "Institución Educativa Privada",
    title2: "TTE MIGUEL CORTÉS - SULLANA",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/ColegioTteMiguelCortes",
        url: "https://www.facebook.com/ColegioTteMiguelCortes",
      },
      {
        icon: faEnvelope,
        name: "info@iepmiguelcortes.edu.pe",
        url: "mailto:info@iepmiguelcortes.edu.pe",
      },
      {
        icon: faLocationDot,
        name: "Miguel Cortes – Sullana",
        url: "https://goo.gl/maps/BUxaWWGoCSoseC7K7",
      },
      {
        icon: faGlobe,
        name: "https://www.iepmiguelcortes.edu.pe",
        url: "https://www.iepmiguelcortes.edu.pe",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1LR4KCTclL0nRqf47SwrQPQpHmnG63e8j/view?usp=sharing",
  },
  {
    image: Inst15,
    imgCarousels: [
      ImgJoseJuaquinPiura,
      ImgCarouselInclanPiura,
      ImgCarouselInclanPiura2,
      ImgCarouselInclanPiura3,
      ImgCarouselInclanPiura4,
      ImgCarouselInclanPiura5,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "CRL JOSÉ JOAQUÍN INCLÁN - PIURA  ",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/inclanpiura",
        url: "https://www.facebook.com/inclanpiura",
      },
      {
        icon: faEnvelope,
        name: "jjinclan@hotmail.es",
        url: "mailto:jjinclan@hotmail.es",
      },
      {
        icon: faLocationDot,
        name: "Av. San Martin N° 900",
        url: "https://www.google.com/maps/place/Urb+Cuartel+Almte.+Miguel+Grau,+Piura+20001/@-5.1421023,-80.8108343,10.17z/data=!4m16!1m10!4m9!1m4!2m2!1d-77.0219014!2d-12.1858658!4e1!1m3!2m2!1d-80.636963!2d-5.1992226!3m4!1s0x904a1a874f9dec03:0x7363f626a0466074!8m2!3d-5.1980054!4d-80.6375476",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1YRo3AGVsv5CEeN719rJZTdSMAjZj_YK7/view?usp=sharing",
  },
  {
    image: Inst22,
    imgCarousels: [
      ImgCarouselEjercitoArequipa,
      ImgCarouselEjercitoArequipa2,
      ImgCarouselEjercitoArequipa4,
      ImgCarouselEjercitoArequipa3,
      ImgCarouselEjercitoArequipa5,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "40159 ”EJÉRCITO AREQUIPA”",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/IE-40159",
        url: "https://m.facebook.com/IE-40159-Del-Ej%C3%A9rcito-Arequipa-1982516118723178",
      },
      {
        icon: faEnvelope,
        name: "informes@colegioejercitoarequipa.com",
        url: "mailto:informes@colegioejercitoarequipa.com",
      },
      {
        icon: faLocationDot,
        name: "Av. Progreso 1220",
        url: "https://www.google.com.pe/maps/place/Instituci%C3%B3n+Educativa+Ej%C3%A9rcito+Arequipa/@-16.3982408,-71.5184189,756m/data=!3m1!1e3!4m9!1m2!2m1!1s40159+EJERCITO+AREQUIPA%E2%80%9D%7D!3m5!1s0x91424ba8ddc31f57:0x7f7dc0980a100ca3!8m2!3d-16.398448!4d-71.5158218!15sChs0MDE1OSBFSkVSQ0lUTyBBUkVRVUlQQeKAnX2SAQZzY2hvb2w!5m1!1e4?hl=es-419",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1YGb-p2Kd4MkDCScp3NQ0arKoMdpiG3oR/view?usp=sharing",
  },
  {
    image: Inst13,
    imgCarousels: [
      ImgAndresAvelinoPuno,
      ImgCarouselAacPuno,
      ImgCarouselAacPuno2,
      ImgCarouselAacPuno3,
      ImgCarouselAacPuno4,
      ImgCarouselAacPuno5,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "ANDRÉS AVELINO CÁCERES - PUNO",
    title3: "INICIAL - PRIMARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/AndresAvelinoPuno",
        url: "https://www.facebook.com/AndresAvelinoPuno",
      },
      {
        icon: faEnvelope,
        name: "iep.aacpuno@gmail.com",
        url: "mailto:iep.aacpuno@gmail.com",
      },
      {
        icon: faLocationDot,
        name: "Andrés Avelino Cáceres - Puno",
        url: "https://goo.gl/maps/EGC9CQZnXv2LRuWK7",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1s6C8H6x-KsgljBkyFqPYQ-EMVwkiPVyt/view?usp=sharing",
  },
  {
    image: Inst21,
    imgCarousels: [
      ImgFranciscoBolonesiCusco,
      ImgCarouselFranciscoBolonesCusco,
      ImgCarouselFranciscoBolonesiCusco7,
      ImgCarouselFranciscoBolonesiCusco8,
      ImgCarouselFranciscoBolonesiCusco5,
      ImgCarouselFranciscoBolonesiCusco6,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "CRL FRANCISCO BOLONESI - CUZCO",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/CoronelFranciscoBolognesi",
        url: "Facebook: https://www.facebook.com/I-E-Crl-Francisco-Bolognesi-104490221717515/?ti=as",
      },
      {
        icon: faEnvelope,
        name: "iebolognesicusco@hotmail.com",
        url: "mailto:iebolognesicusco@hotmail.com",
      },
      {
        icon: faLocationDot,
        name: "Crl Francisco Bolognesi – Cusco",
        url: "https://goo.gl/maps/Su8i45tpDbz6tdVi6",
      },
      {
        icon: faGlobe,
        name: "https://iecfb.edu.pe/",
        url: "https://iecfb.edu.pe/",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1NEi0wH2x6cAErspXBabI1YXh7kRFxnxX/view?usp=sharing",
  },
  {
    image: Inst16,
    imgCarousels: [
      ImgCarouselNuestrosHeroes,
      ImgCarouselNuestrosHeroes1,
      ImgCarouselNuestrosHeroes2,
      ImgCarouselNuestrosHeroes3,
      ImgCarouselNuestrosHeroes4,
      ImgCarouselNuestrosHeroes5,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "NUESTROS HÉROES DE LA GUERRA DEL PACÍFICO - TACNA",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/colegio.nhgp",
        url: "https://www.facebook.com/nhgp.edu.pe/",
      },
      {
        icon: faEnvelope,
        name: "i.e.e.nhgp42217@gmail.com",
        url: "mailto:i.e.e.nhgp42217@gmail.com",
      },
      {
        icon: faLocationDot,
        name: "Nuestros Héroes Guerra del Pacifico – Tacna",
        url: "https://goo.gl/maps/zAS7qGYPxNNVVUic9",
      },
      {
        icon: faGlobe,
        name: "http://nhgp.edu.pe/",
        url: "http://nhgp.edu.pe/",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1OV5pmYy4FFrE-WI-FdPsq6blIvBXc9K9/view?usp=sharing",
  },
  {
    image: Inst12,
    imgCarousels: [
      ImgCarouselAacLocumba,
      ImgCarouselAacLocumba2,
      ImgCarouselAacLocumba3,
      ImgCarouselAacLocumba4,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "ANDRÉS AVELINO CÁCERES - LOCUMBA",
    title3: "INICIAL - PRIMARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/profile",
        url: "https://www.facebook.com/profile.php?id=100010163318895",
      },
      {
        icon: faEnvelope,
        name: "Nelly_7_1@hotmail.com",
        url: "mailto:Nelly_7_1@hotmail.com",
      },
      {
        icon: faLocationDot,
        name: "Andrés Avelino Cáceres – Locumba",
        url: "https://goo.gl/maps/fJH4JFEpZevNLvQZ6",
      },
    ],
  },
  {
    image: Inst12,
    imgCarousels: [
      ImgCarouselRamonZavalaLocumba,
      ImgCarouselRamonZavalaLocumba2,
      ImgCarouselRamonZavalaLocumba3,
      ImgCarouselRamonZavalaLocumba4,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "CRL RAMÓN ZAVALA SUÁREZ - LOCUMBA",
    title3: "INICIAL",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/RAMON.ZAVALA.90834776",
        url: "https://www.facebook.com/ramon.zavala.90834776",
      },
      {
        icon: faEnvelope,
        name: "Nelly_7_1@hotmail.com",
        url: "mailto:Nelly_7_1@hotmail.com",
      },
      {
        icon: faLocationDot,
        name: "Ramón Zavala Suarez – Locumba",
        url: "https://goo.gl/maps/fJH4JFEpZevNLvQZ6",
      },
    ],
  },
  {
    image: Inst17,
    imgCarousels: [
      ImgCarouselAacIquitos,
      ImgCarouselAacIquitos2,
      ImgCarouselAacIquitos3,
      ImgCarouselAacIquitos4,
      ImgCarouselAacIquitos5,
      ImgCarouselAacIquitos6,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "MCAL ANDRÉS AVELINO CÁCERES - Iquitos",
    title3: "PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "ANDRÉS AVELINO CÁCERES",
        url: "https://www.facebook.com/Colegio-MAAC-111412396891577/",
      },
      {
        icon: faEnvelope,
        name: "mesadepartesmaac@gmail.com",
        url: "mailto:mesadepartesmaac@gmail.com",
      },
      {
        icon: faLocationDot,
        name: "MCAL ANDRÉS AVELINO CÁCERES - Iquitos",
        url: "https://www.google.com/maps/place/3%C2%B044'49.6%22S+73%C2%B015'48.6%22W/@-3.7471039,-73.2635117,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x992530265f7edf71!8m2!3d-3.7471039!4d-73.2635117",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1mpOrbslYfssMhQls1CaSk96xSuFTtb_W/view?usp=sharing",
  },
  {
    image: Inst18,
    imgCarousels: [
      ImgTarapacaIquitos,
      ImgCarouselTarapaca2,
      ImgCarouselTarapaca4,
      ImgCarouselTarapaca5,
      ImgCarouselTarapaca6,
    ],
    title1: "Institución Educativa",
    title2: "TARAPACÁ - IQUITOS",
    title3: "INICIAL - PRIMARIA",
    socialLinks: [
      {
        icon: faFacebook,
        name: "facebook.com/Colegio%20Tarapaca",
        url: "https://www.facebook.com/profile.php?id=100054614057405",
      },
      {
        icon: faEnvelope,
        name: "Tarapacaiquitos@hotmail.com",
        url: "mailto:Tarapacaiquitos@hotmail.com",
      },
      {
        icon: faLocationDot,
        name: "Tarapacá – Iquitos",
        url: "https://goo.gl/maps/Uvr6UkERhGMaRgq1A",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1wPyMTm7Q2PGc74V4b0K4ULHGDMbEgni7/view?usp=sharing",
  },
  {
    image: Inst19,
    imgCarousels: [
      ImgIeMariaMontessori,
      ImgCarouselMariaMontesori,
      ImgCarouselMariaMontesori2,
      ImgCarouselMariaMontesori3,
      ImgCarouselMariaMontesori4,
      ImgCarouselMariaMontesori5,
      ImgCarouselMariaMontesori6,
    ],
    title1: "Institución Educativa",
    title2: "N° 169 MARÍA MONTESSORI - IQUITOS",
    title3: "INICIAL",
    socialLinks: [
      {
        icon: faFacebook,
        name: "mariamontessori169iquitos",
        url: "https://www.facebook.com/maria.montessori.1441810",
      },
      {
        icon: faEnvelope,
        name: "mariamontessori169.2017@gmail.com",
        url: "mailto:mariamontessori169.2017@gmail.com",
      },
      {
        icon: faLocationDot,
        name: "María Montessori – Iquitos",
        url: "https://goo.gl/maps/9eVEJACa887wLkWr6",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1FhLPTjfPA5r4ELVII4K5Q0P4y4svAWe0/view?usp=sharing",
  },
];
